import { cva } from "class-variance-authority";

export const sheetVariants = cva(
  "bg-background fixed z-100 flex flex-col gap-4 px-6 shadow-lg transition ease-in-out",
  {
    variants: {
      kind: {
        // Radix keeps the node mounted while closing, so data-[state] drives both enter and exit.
        // panel unmounts immediately on close (if !open return null), so only the enter animation fires.
        modal:
          "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
        panel: "animate-in duration-500",
      },
      side: {
        right: "inset-y-0 right-0 h-full w-3/4 sm:max-w-sm",
        left: "inset-y-0 left-0 h-full w-3/4 sm:max-w-sm",
        top: "inset-x-0 top-0 h-auto",
        bottom: "inset-x-0 bottom-0 h-auto",
      },
    },
    compoundVariants: [
      {
        kind: "modal",
        side: "right",
        className:
          "data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right",
      },
      {
        kind: "modal",
        side: "left",
        className:
          "data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left",
      },
      {
        kind: "modal",
        side: "top",
        className:
          "data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
      },
      {
        kind: "modal",
        side: "bottom",
        className:
          "data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
      },
      { kind: "panel", side: "right", className: "slide-in-from-right" },
      { kind: "panel", side: "left", className: "slide-in-from-left" },
      { kind: "panel", side: "top", className: "slide-in-from-top" },
      { kind: "panel", side: "bottom", className: "slide-in-from-bottom" },
    ],
    defaultVariants: { kind: "panel", side: "right" },
  }
);
